import React, { useState, useMemo, useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import useStore from '../../states/store';
import TabPanel from '../../components/TabPanel';
// Components
import Table from './components/Table';
import AddAgendaModal from './components/AddAgendaModal';
import UpdateAgendaModal from './components/UpdateAgendaModal';
// Context
import useWwwContext from './context/useWwwContext';
// API
import { getWWWListing, getAgenda, postArchiveAgenda, postRestoreAgenda } from '../../api/wwwApi';

export default function WWWellMaintenance() {
  const auth = useStore((state) => state.auth);

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [wwwData, setWwwData] = useState([]);
  const [agenda, setAgenda] = useState({});
  const [addAgendaModal, setAddAgendaModal] = useState({ toggle: false });
  const [updateAgendaModal, setUpdateAgendaModal] = useState({ toggle: false });

  const handleGenerateList = async (tab = null) => {
    try {
      setLoading(true);
      const request = {
        achived: tab ?? 0,
      };

      const response = await getWWWListing(request);
      const { code, data } = response.data;

      if (code === '200') {
        setWwwData(data);
      }
      setLoading(false);
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
    handleGenerateList(newValue);
  };

  const handleUpdate = async (value) => {
    try {
      const request = {
        id: value,
      };

      const response = await getAgenda(request);
      const { code, data } = response.data;

      if (code === '200') {
        setAgenda(data);
        setUpdateAgendaModal({ ...updateAgendaModal, toggle: true });
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const hanldeArchied = async (value) => {
    try {
      const request = {
        id: value,
      };

      const { isConfirmed } = await Swal.fire({
        title: 'Approvals',
        text: `Are you sure you want to archive what went well?`,
        icon: 'warning',
        showCancelButton: true,
      });

      if (!isConfirmed) {
        return;
      }

      toast.loading('Processing request please kindly wait');
      const response = await postArchiveAgenda(request);
      const { code, message } = response.data;

      if (code === '200') {
        toast.success(message);
        handleGenerateList(activeTab);
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleRestore = async (value) => {
    try {
      const request = {
        id: value,
      };

      const { isConfirmed } = await Swal.fire({
        title: 'Approvals',
        text: `Are you sure you want to restore what went well?`,
        icon: 'warning',
        showCancelButton: true,
      });

      if (!isConfirmed) {
        return;
      }

      toast.loading('Processing request please kindly wait');

      const response = await postRestoreAgenda(request);
      const { code, message } = response.data;

      if (code === '200') {
        toast.success(message);
        handleGenerateList(activeTab);
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  useEffect(() => {
    handleGenerateList();
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <useWwwContext.Provider
        value={useMemo(
          () => ({
            auth,
            activeTab,
            loading,
            wwwData,
            addAgendaModal,
            updateAgendaModal,
            agenda,
            setLoading,
            setWwwData,
            setAddAgendaModal,
            setUpdateAgendaModal,
            handleUpdate,
            hanldeArchied,
            handleGenerateList,
            handleRestore,
          }),
          [loading, wwwData, addAgendaModal.toggle, updateAgendaModal.toggle, agenda],
        )}
      >
        <Box padding={4}>
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={12} md={12}>
                  <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={activeTab}
                        onChange={handleChangeActiveTab}
                        aria-label='basic tabs example'
                      >
                        <Tab label='List of What Went Well' id='lising' aria-controls='listing' />
                        <Tab label='Archived' id='archived' aria-controls='archived' />
                      </Tabs>
                    </Box>
                    <TabPanel value={activeTab} index={activeTab}>
                      <Table />
                    </TabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <AddAgendaModal />
        {updateAgendaModal.toggle ? <UpdateAgendaModal /> : ''}
      </useWwwContext.Provider>
    </div>
  );
}
